import type { MarketDataSnapshot, Security, SparklineValues } from '@talos/kyoko';
import { createContext, useContext } from 'react';

export const MarketDataContext = createContext<{
  marketDataByCurrency: Map<string, { marketData: MarketDataSnapshot; security: Security }>;
  sparklineBySymbol: Map<string, SparklineValues | undefined> | undefined;
}>(null!);

export function useMarketDataContext() {
  const context = useContext(MarketDataContext);
  if (!context) {
    throw new Error('useMarketDataContext must be used within a MarketDataContext');
  }
  return context;
}
